import React, { createContext, useContext, useState } from 'react';

const HelpContext = createContext();

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return context;
};

export const HelpProvider = ({ children }) => {
  const [isGlobalHelpOpen, setIsGlobalHelpOpen] = useState(false);
  const [isPageHelpOpen, setIsPageHelpOpen] = useState(false);
  const [currentPageHelp, setCurrentPageHelp] = useState(null);

  const openGlobalHelp = () => {
    setIsGlobalHelpOpen(true);
    setIsPageHelpOpen(false);
  };

  const closeGlobalHelp = () => {
    setIsGlobalHelpOpen(false);
  };

  const openPageHelp = (pageName) => {
    setCurrentPageHelp(pageName);
    setIsPageHelpOpen(true);
    setIsGlobalHelpOpen(false);
  };

  const closePageHelp = () => {
    setIsPageHelpOpen(false);
    setCurrentPageHelp(null);
  };

  const value = {
    isGlobalHelpOpen,
    isPageHelpOpen,
    currentPageHelp,
    openGlobalHelp,
    closeGlobalHelp,
    openPageHelp,
    closePageHelp
  };

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
};
